import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Order as SchemaOrder } from '../schemas/Order';
import { type OrderWithDeliveryOptions as SchemaOrderWithDeliveryOptions } from '../schemas/OrderWithDeliveryOptions';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateSnapshotContentType = '' as const;
export type UpdateSnapshotRequest = undefined;
export type UpdateSnapshotResponses = LinkCommonErrorResponses & {
    /**
     * @description Snapshot updated
     */
    '200': {
        'application/json': SchemaOrder & SchemaOrderWithDeliveryOptions;
    };
};
export type UpdateSnapshotResponseSuccess = UpdateSnapshotResponses['200']['application/json'];
export type UpdateSnapshotSearchParams = {
    signature: string;
};
export type UpdateSnapshotPathParameters = {
    store_slug: string;
    order_id: string;
};
export const UpdateSnapshotUrl = '/{store_slug}/orders/{order_id}/snapshot' as const;
export const UpdateSnapshotMethod = 'POST' as const;
export const getUpdateSnapshotUrl = (params: UpdateSnapshotPathParameters) =>
    UpdateSnapshotUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateSnapshotPathParameters) =>
        String(params[param])
    );
